import React, { Fragment, useState, useEffect, useCallback } from 'react';

import { getLang } from '@Sage/ssm-utils';

import { getLiteralsLogin } from 'lib/services/literals';
export default () => {
    const [loading, setLoading] = useState(true);
    const [literals, setLiterals] = useState();
    const lang = getLang();

    const t = useCallback(
        (key, params) => {
            let literal = literals?.[key] || key;
            if (params && params.length > 0 && literal) {
                literal = literal.replace(/%([0-9]+)\$s/g, '%@');
                if (literal.includes('%@')) {
                    const appearances = literal.match(new RegExp('%@', 'g')).length;
                    for (let i = 0; i < appearances && i < params.length; i++) {
                        literal = literal.replace('%@', params[i]);
                    }
                }
            }
            return literal;
        },
        [literals],
    );

    const getLiteralWithParametersHtml = useCallback(
        (literal, params = [], customizeParameter) => {
            let result = t(literal);
            if (params && params.length > 0 && result) {
                result = result.replace(/%([0-9]+)\$s/g, '%@');
                if (result.includes('%@')) {
                    const appearances = result.match(new RegExp('%@', 'g'));
                    let lastIndex = 0;
                    let resultParts = [];
                    appearances.forEach((app, index) => {
                        const currentIndex = result.indexOf('%@', lastIndex);
                        resultParts.push(result.slice(lastIndex, currentIndex));
                        resultParts.push(
                            customizeParameter
                                ? customizeParameter(params[index], index)
                                : params[index],
                        );
                        lastIndex = currentIndex + 2;
                    });
                    if (lastIndex < result.length) {
                        resultParts.push(result.slice(lastIndex, result.length));
                    }

                    return (
                        <Fragment>
                            {resultParts.map((part, index) =>
                                typeof part === 'object' ? { ...part, key: `part-${index}` } : part,
                            )}
                        </Fragment>
                    );
                }
            }
            return result;
        },
        [t],
    );

    useEffect(() => {
        if (literals) return;

        getLiteralsLogin(lang)
            .then(({ data }) => {
                setLiterals(data || {});
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.error(e);
            });
    }, [lang, literals]);

    return { loading, t, lang, getLiteralWithParametersHtml };
};
